export const fetchChatBlackList = (): Promise<string> =>
  fetch(
    `https://storage.googleapis.com/resources.tango.me/tango-officer-resources/chat_only_blacklist_v1.txt`
  ).then((response) => response.text());
